import { render, staticRenderFns } from "./myPop.vue?vue&type=template&id=1bc0dfe1&"
import script from "./myPop.vue?vue&type=script&lang=js&"
export * from "./myPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports